import { NewNames as NewNamesForm } from '@bgea-js/form-templates';
import customModalHeaderRP from "../../../../src/content/ride-signup-and-watch-page/customModalHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  customModalHeaderRP,
  React
};